import { PrinterOutlined } from "@ant-design/icons";
import { Affix, Button, Card, Form, notification, Space, Spin } from "antd";
import { IOU_ADJUSTMENT_GENERAL_LIST, IOU_ADJUSTMENT_GENERAL_PDF } from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import HandleNotification from "common/Notification";
import { isMobileView } from "components/Common/AppHelper";
import Header from "components/Common/Header";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import IOUAdjustmentGeneralForm from "../IOUAdjustmentGeneralForm";

const UpdateIOUAdjustmentGeneral = (props) => {
  const { width, viewMode, mode } = props;

  const [editInfo, setEditInfo] = useState({});
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { iouCostId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [printLoading, setPrintLoading] = useState(false);

  const currentUser = useSelector((state) => state.auth?.user);

  const getIOUCostInfo = useCallback(async (id) => {
    setIsLoading(true);
    const query = `${IOU_ADJUSTMENT_GENERAL_LIST}/${id}`;
    const response = await getData(query);

    if (response && response?.status === 200) {
      const iouCostData = response?.data?.data;
      setEditInfo(iouCostData);
    } else {
      HandleNotification("error", "Error!", response?.message || "Failed to get IOU data");
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (iouCostId) {
      getIOUCostInfo(iouCostId);
    }
  }, [iouCostId, getIOUCostInfo]);

  const discardForm = () => {
    navigate("/import-export-expense-tracking/iou-adjustment-for-general");
  };

  const handlePrint = async () => {
    const id = editInfo?.id || iouCostId;
    if (!id) return;
    try {
      setPrintLoading(true);
      const response = await getData(
        `${IOU_ADJUSTMENT_GENERAL_PDF}/${id}`,
        false,
        null,
        null,
        "arraybuffer",
      );
      const data = response?.data;
      const header =
        data && data.byteLength >= 4
          ? String.fromCharCode(...new Uint8Array(data.slice(0, 4)))
          : "";
      if (response?.status === 200 && header === "%PDF") {
        const iouNo = editInfo?.iou_info?.iou_number || id;
        const url = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `miscellaneous_bill_general_${iouNo}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 100);
      } else {
        HandleNotification("error", "bottomRight", "Error getting PDF report!", null);
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Failed to download Miscellaneous Bill PDF",
        placement: "topRight",
      });
    } finally {
      setPrintLoading(false);
    }
  };

  const updateIOUCost = async () => {
    if (submitting) {
      return;
    }

    try {
      // Do not restore invoice_ids from editInfo — respect the user's current selection
      await form.validateFields();

      form.submit();
    } catch (error) {
      if (error.errorFields && error.errorFields.length > 0) {
        const fieldMessages = error.errorFields
          .map((field) => field.errors?.[0])
          .filter(Boolean)
          .slice(0, 3);
        notification.error({
          message: "Validation Error",
          description:
            fieldMessages.length > 0
              ? fieldMessages.join(" | ")
              : "Please fill in all required fields correctly.",
          placement: "topRight",
        });
      } else {
        notification.error({
          message: "Error",
          description: "Failed to update IOU Adjustment for General",
          placement: "topRight",
        });
      }
    }
  };

  const ActionUI = () => {
    return (
      <Space>
        <Button size="small" key={1} danger onClick={() => discardForm()} disabled={submitting}>
          {viewMode ? "Back" : "Discard"}
        </Button>

        {(editInfo?.id || iouCostId) && (
          <Button
            size="small"
            key="print"
            icon={<PrinterOutlined />}
            onClick={handlePrint}
            loading={printLoading}
          >
            Print
          </Button>
        )}

        {!viewMode && (
          <Button
            size="small"
            key={2}
            type="primary"
            onClick={() => updateIOUCost()}
            disabled={submitting}
            loading={submitting}
          >
            Update
          </Button>
        )}
      </Space>
    );
  };
  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "90vh",
          backgroundColor: "#fff",
        }}
      >
        <Spin spinning={isLoading} />
      </div>
    );
  }

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed" style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}>
          <Header
            title={`${viewMode ? "View" : "Edit"} IOU Adjustment for General`}
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={<ActionUI />}
          />
        </Card>
      </Affix>

      {/* {canUpdate && !viewMode ? (
        <IOUDocumentsForm
          form={form}
          isEdit={true}
          viewMode={viewMode}
          editInfo={editInfo}
          currentUser={currentUser}
          mode={mode}
          canUpdate={canUpdate}
          getIOUCostInfo={getIOUCostInfo}
        />
      ) : canView && viewMode ? ( */}
      <Spin spinning={isLoading}>
        <IOUAdjustmentGeneralForm
          form={form}
          isEdit={true}
          viewMode={viewMode}
          editInfo={editInfo}
          currentUser={currentUser}
          mode={mode}
          getIOUCostInfo={getIOUCostInfo}
          onSubmittingChange={setSubmitting}
        />
      </Spin>
      {/*  */}
    </>
  );
};

export default UpdateIOUAdjustmentGeneral;
